var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40004 15.1667H4.60004C1.99337 15.1667 0.833374 14.0067 0.833374 11.4V8.6C0.833374 5.99333 1.99337 4.83333 4.60004 4.83333H7.40004C10.0067 4.83333 11.1667 5.99333 11.1667 8.6V11.4C11.1667 14.0067 10.0067 15.1667 7.40004 15.1667ZM4.60004 5.83333C2.53337 5.83333 1.83337 6.53333 1.83337 8.6V11.4C1.83337 13.4667 2.53337 14.1667 4.60004 14.1667H7.40004C9.46671 14.1667 10.1667 13.4667 10.1667 11.4V8.6C10.1667 6.53333 9.46671 5.83333 7.40004 5.83333H4.60004Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 11.1667H10.6667C10.3934 11.1667 10.1667 10.94 10.1667 10.6667V8.6C10.1667 6.53333 9.46671 5.83333 7.40004 5.83333H5.33337C5.06004 5.83333 4.83337 5.60667 4.83337 5.33333V4.6C4.83337 1.99333 5.99337 0.833333 8.60004 0.833333H11.4C14.0067 0.833333 15.1667 1.99333 15.1667 4.6V7.4C15.1667 10.0067 14.0067 11.1667 11.4 11.1667ZM11.1667 10.1667H11.4C13.4667 10.1667 14.1667 9.46667 14.1667 7.4V4.6C14.1667 2.53333 13.4667 1.83333 11.4 1.83333H8.60004C6.53337 1.83333 5.83337 2.53333 5.83337 4.6V4.83333H7.40004C10.0067 4.83333 11.1667 5.99333 11.1667 8.6V10.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.a78d9d8433fab0eee8755eb460be5860.svg";
export { ForwardRef as ReactComponent };